import { of, concat, from } from 'rxjs';
import { bufferToggle, switchMap } from 'rxjs/operators';
// Buffer values until the closing observable emits, then emit buffered values and switch to original stream
export function bufferUntil(closing) {
    return function (stream) {
        return stream.pipe(bufferToggle(of(false), function () { return closing; }), switchMap(function (initial) { return concat(from(initial), stream); }));
    };
}
//# sourceMappingURL=buffer-until.js.map